/**
 * ServiceAlert API Documentation
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MapLayerType = {
    Unknown: 'UNKNOWN',
    Wms: 'WMS',
    Wmts: 'WMTS',
    Tilelayer: 'TILELAYER',
    Arcgisrest: 'ARCGISREST'
} as const;
export type MapLayerType = typeof MapLayerType[keyof typeof MapLayerType];

